<div class="iso-content-header">
  <div class="header">
    <!-- <div class="iso-app-menu">
        <i class="material-icons iso-material-icons white">apps</i>
      </div> -->
    <div class="iso-brand">
      <img
        src="assets/images/verisk_tm_h_white_rgb.svg"
        border="0"
        height="25px"
      />
    </div>
    <div>
      <span class="mat-display-1 appname"> MSP Navigator Site Admin </span>
    </div>
    <div class="iso-header-boxes">
      <div class="div-search-client">
        <form class="search-form">
          <mat-form-field class="clients-form-field" [style.width] = searchBarWidth>
            <mat-label
              class="clients-placeholder"
              *ngIf="!myControl.value || myControl.value === ''"
            >
              Select Client
            </mat-label>
            <mat-icon
              matPrefix
              class="selected-client-federated-icon"
              matTooltip="Federated Client"
              *ngIf="isSelectedFederatedClient()"
            >
              how_to_reg
            </mat-icon>
            <input
              #inputAutoComplete
              [formControl]="myControl"
              [matAutocomplete]="auto"
              #trigger="matAutocompleteTrigger"
              matInput
              type="text"
              (input)="onInputChange()"
            />

            <app-autocomplete-suffix-actions
              matSuffix
              [showClear]="myControl.value !== null && myControl.value !== ''"
              [panelOpen]="trigger.panelOpen"
              (clearClicked)="clearInput($event)"
              (toggleClicked)="openOrClosePanel($event, trigger)">
            </app-autocomplete-suffix-actions>

            <mat-autocomplete
              #auto="matAutocomplete"
              [clearStaleSelectionOnOpen]="myControl.value"
              (opened)="onPanelOpened()"
              (optionSelected)="onOptionSelected($event)"
              [displayWith]="displayFn"
              panelClass="custom-autocomplete-panel"
            >
              <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    gap: 0px;
                    width: 100%;
                  "
                >
                  <span
                    style="
                      height: 24px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <ng-container
                      *ngIf="option.OKTALoginType === 'F'; else emptySpace"
                    >
                      <mat-icon
                        style="
                          color: #2196f3;
                          font-size: 18px;
                          vertical-align: middle;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          height: 24px;
                        "
                        matTooltip="Federated Client"
                      >
                        how_to_reg
                      </mat-icon>
                    </ng-container>
                    <ng-template #emptySpace>
                      <span style="width: 40px; display: inline-block"></span>
                    </ng-template>
                  </span>
                  <span
                    style="height: 24px; display: flex; align-items: center"
                  >
                    {{ option.DisplayName }}
                  </span>
                </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </form>
      </div>
      <div class="iso-header-user">
        <!-- <span style="padding-right: 5px;">{{localize.header.HEADER_WELCOME || 'Welcome'}}, {{UserFullName}}</span> -->
        <span style="padding-right: 5px">Welcome, {{ username }}</span>
      </div>
      <div class="iso-header-links">
        <span
          style="margin-right: 20pt; cursor: pointer"
          matTooltip="Logout"
          (click)="logout()"
          *ngIf="(_oktaStateService.authState$ | async)?.isAuthenticated"
        >
          <mat-icon
            aria-hidden="false"
            aria-label="Example home icon"
            style="color: white"
            >logout</mat-icon
          >
        </span>
      </div>
    </div>
  </div>
</div>
